import type {FetchBaseQueryError} from '@reduxjs/toolkit/query';
import type {ApiResponseBody, ApiResponseBodyError, ApiResponseBodySuccess} from '../types';

export const buildURLSearch = (params: any = {}) => {
  return (
    '?' +
    Object.entries(params)
      .filter((entry) => entry[1] != null)
      .flatMap(([key, value]) =>
        (value instanceof Array ? value : [value]).map((v) => `${key}=${encodeURIComponent(`${v}`)}`),
      )
      .join('&')
  );
};

export const checkApiError = (arg: unknown, statusCode: string) => {
  return isFetchBaseQueryError(arg) && isApiResponseBodyError(arg.data) && arg.data.statusCode === statusCode;
};

export const isApiResponseBody = (arg: unknown): arg is ApiResponseBody => {
  return (
    typeof arg === 'object' &&
    arg != null &&
    // 'data' in arg &&
    'message' in arg &&
    'status' in arg &&
    'statusCode' in arg
  );
};

export const isApiResponseBodyError = (arg: unknown): arg is ApiResponseBodyError => {
  return isApiResponseBody(arg) && arg.status === 'error';
};

export const isApiResponseBodySuccess = (arg: unknown): arg is ApiResponseBodySuccess => {
  return isApiResponseBody(arg) && arg.status === 'success';
};

export const isFetchBaseQueryError = (arg: any): arg is FetchBaseQueryError => {
  return (
    typeof arg === 'object' &&
    arg != null &&
    'status' in arg &&
    ((typeof arg.status === 'number' && 'data' in arg) ||
      (typeof arg.status === 'string' && 'error' in arg && typeof arg.error === 'string'))
  );
};
